const DNI_BLACKLIST = ['12345678', '87654321'];

const REPEATED_NUMBERS_REGEX = /^(\d)\1+$/;

export default function isDNIValid(dni: string) {
  const customerDNI = dni.replace(/[^\d]+/g, '');

  if (customerDNI.match(REPEATED_NUMBERS_REGEX)) return false;

  if (DNI_BLACKLIST.includes(customerDNI)) return false;

  if (customerDNI.length !== 8) return false;

  return true;
}
